
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { classNames } from '../../common/css';

export const Error = (props) => {
    const { title, children, className, actions } = props;
    
    return (
        <div className={classNames("flex flex-col items-center justify-center py-12 px-4", className)}>
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-surface-inset mb-4">
                <ExclamationTriangleIcon className="h-7 w-7 text-foreground-subtle" aria-hidden="true" />
            </div>
            <div className="text-center">
                {title && (
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                        {title}
                    </h3>
                )}
                {children && (
                    <div className="text-sm text-foreground-muted leading-relaxed max-w-md">
                        {children}
                    </div>
                )}
                {actions && (
                    <div className="mt-4 flex justify-center space-x-3">
                        {actions}
                    </div>
                )}
            </div>
        </div>
    );
};